<template>
  <v-container fluid>
    <MultiVariableLineChart title="Histórico de variables" :vars="vars" :selected_var="selected_var" :is_analizador="is_analizador"></MultiVariableLineChart>
  </v-container>
</template>

<script>
import MultiVariableLineChart from "@/components/utils/MultiVariableLineChart.vue";

export default {
  name: "HistoryPage",

  components: {
    MultiVariableLineChart,
  },
  data(){
    return{
      vars: [],
      selected_var: null,
      is_analizador: false,
    }
  },
  async mounted() {
    const { variables, selected_var, is_analizador } = this.$route.query;
    if (variables && selected_var) {
      // const {variables} = await this.getVarDataForTemp(temperaturas.map((t) => t.var_address));
      this.selected_var = selected_var;
      this.vars = variables;
      this.is_analizador = is_analizador === "true";
    }
  }
  
};
</script>
